'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadFailed = loadFailed;
exports.loadServerError = loadServerError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_FAIL = 'redux-example/initialLoadSuccess/LOAD_FAIL';
var LOAD_SERVER_ERROR = 'redux-example/initialLoadSuccess/LOAD_SERVER_ERROR';

var initialState = {
  page: true,
  server: true
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        page: false
      });
    case LOAD_SERVER_ERROR:
      return (0, _extends3.default)({}, state, {
        server: false
      });
    default:
      return state;
  }
}

function loadFailed() {
  return {
    type: LOAD_FAIL
  };
}

function loadServerError() {
  return {
    type: LOAD_SERVER_ERROR
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/initialLoadSuccess.js
// module id = 98
// module chunks = 47